module.exports = __webpack_public_path__ + "img/upi-pg.198d7ad7.svg";